var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHunter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.12 26.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m22.12,13.36l-1.69-.85s-.38-6.4-.66-7.44c-.28-1.04-5.65-5.08-8.75-5.08S2.35,4.52,2.35,4.52l-.85,8-1.51.85.47,4.71,2.07,1.04s0,1.69.56,3.11c.56,1.41,5.93,4.52,8.09,4.52s4.89-2.35,6.78-3.48c1.88-1.13,1.69-4.14,1.69-4.14l1.88-1.04.56-4.71ZM4.05,5.18l1.41-1.04s1.13.47,2.82.47,1.69,1.04,1.69,1.79,1.69,1.79,2.73,1.13c1.04-.66,1.41-2.64.56-3.39s-2.35-1.79-2.21-2.16,2.59.19,7.01,3.29v.85s-1.69-.85-2.45.19c-.75,1.04.09,1.79-.75,2.07-.85.28-2.26-.19-2.73.75,0,0-3.39-.28-5.27.38v-2.73c0-.85-1.41-1.32-2.82-.66v-.94Zm7.01,5.65c5.51-.09,7.76,2.54,7.76,2.54l-1.88,1.41s-2.45-1.69-5.88-1.41c-3.44.28-5.98,1.41-5.98,1.41l-2.16-1.41s2.64-2.45,8.14-2.54Zm8.99,6.4l-1.98,1.22s.09,1.88-.66,3.2c-.75,1.32-4.89,3.39-6.35,3.48-1.46.09-3.06-1.13-5.04-2.26-1.98-1.13-1.98-4.52-1.98-4.52l-2.26-1.13v-3.11s1.36,1.84,2.78,2.26c1.41.42,2.73-1.46,6.31-1.6,3.58-.14,4.8,1.36,6.26,1.51,1.46.14,3.2-2.16,3.2-2.16l-.28,3.11Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHunter);
export default __webpack_public_path__ + "static/media/hunter.55f295d042e0fe1471998f377019ea02.svg";
export { ForwardRef as ReactComponent };